import { render, staticRenderFns } from "./CustomersSegments.vue?vue&type=template&id=25fd87d0&scoped=true"
import script from "./CustomersSegments.vue?vue&type=script&lang=js"
export * from "./CustomersSegments.vue?vue&type=script&lang=js"
import style0 from "./CustomersSegments.vue?vue&type=style&index=0&id=25fd87d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fd87d0",
  null
  
)

export default component.exports